"use client";

import { Box } from "@mui/material";
import type { SxProps, Theme } from "@mui/material";
import {
  actionSx,
  caretDownSx,
} from "@/src/components/common/broadsheet/tokens";

const DisclosureButton = ({
  label,
  open,
  onToggle,
  controls,
  sx,
}: {
  label: string;
  open: boolean;
  onToggle: () => void;
  controls?: string;
  sx?: SxProps<Theme>;
}) => (
  <Box
    component="button"
    type="button"
    onClick={onToggle}
    aria-expanded={open}
    aria-controls={controls}
    className="bf-ui"
    sx={[
      actionSx("outline", "small"),
      { cursor: "pointer", flex: "none" },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  >
    {label}
    <Box component="span" aria-hidden="true" sx={caretDownSx(open)} />
  </Box>
);

export default DisclosureButton;
